export const EvolutionGames = {
 
  SpeedRoulette: {
    redirectUrl: "/casino/ezgevo-speed-roulette",
    code: "1000148",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/evolution/SpeedRoulette-new.webp",
    alt: "",
    name: "Speed Roulette",
    providerName: "Evolution",
  },
  SuperAndarbahar: {
    code: "98789",
    casino: "ezugi",
    provider: "Evolution",
    homeUrl: "http://localhost:3000/Casino",
    alt: "super Andar bahar",
    name: "Super Andar Bahar",
    providerName: "Evolution",
    imgUrl: "./images/evolution/superandarbahar-New.webp",
    redirectUrl: "/casino/aggapevolutiongaming-super-andar-bahar",
  },
  DragonTiger: {
    code: "98790",
    casino: "ezugi",
    provider: "Evolution",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Dragon Tiger",
    name: "Dragon Tiger",
    providerName: "Evolution",
    imgUrl: "./images/evolution/DragonTiger-new.webp",
    redirectUrl: "/casino/ezgevo-dragon-tiger-evo",
  },
 
  SpeedCricketBaccarat: {
    redirectUrl: "/casino/ezgevo-speed-baccarat-x",
    code: "101",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/evolution/SpeedBaccaratx-new.webp",
    alt: "",
    name: "Speed Baccarat X",
    providerName: "Evolution",
  },
  // BlackjackSilverD: {
  //   redirectUrl: "/casino/ezgevo-blackjack-silver-d",
  //   code: "1000044",
  //   casino: "ezugi",
  //   provider: "",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/blackjack/Blackjack-Silver-D.webp",
  //   alt: "",
  //   name: "Blackjack Silver D",
  //   providerName: "Evolution",
  // },
  // BlackjackVIPE: {
  //   redirectUrl: "/casino/ezgevo-blackjack-vip-e",
  //   code: "1000052",
  //   casino: "ezugi",
  //   provider: "",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/blackjack/Blackjack-VIP-E.webp",
  //   alt: "",
  //   name: "Blackjack VIP E",
  //   providerName: "Evolution",
  // },
  // SpeedBlackjackD: {
  //   redirectUrl: "/casino/ezgevo-speed-blackjack-d",
  //   code: "1000033",
  //   casino: "ezugi",
  //   provider: "",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/blackjack/Speed-Blackjack-D1.webp",
  //   alt: "",
  //   name: "Speed Blackjack D",
  //   providerName: "Evolution",
  // },
  // BlackjackVIPL: {
  //   redirectUrl: "/casino/ezgevo-blackjack-vip-l",
  //   code: "1000056",
  //   casino: "ezugi",
  //   provider: "",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/blackjack/BlackjackVIPL-new.webp",
  //   alt: "",
  //   name: "Blackjack VIP L",
  //   providerName: "Evolution",
  // },
  Autoroulette: {
    code: "56768",
    casino: "ezugi",
    provider: "Evolution",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Auto Roulette",
    name: "Auto Roulette",
    providerName: "Evolution",
    imgUrl: "./images/evolution/AutoRoulette-new.webp",
    redirectUrl: "/casino/ezg-auto-roulette",
  },
  ClassicSpeedBlackjack3: {
    redirectUrl: "/casino/ezgevo-classic-speed-blackjack-3",
    code: "1000228",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/evolution/Speed-Blackjack-3.webp",
    alt: "",
    name: " Classic Speed Blackjack 3  ",
    providerName: "Evolution",
  },
  // Hand2CasinoHoldem: {
  //   redirectUrl: "/casino/ezgevo-2-hand-casino-holdem",
  //   code: "1000073",
  //   casino: "ezugi",
  //   provider: "",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/poker/2HandCasinoHoldem-new.webp",
  //   alt: "",
  //   name: " 2 Hand Casino Holdem",
  //   providerName: "Evolution",
  // },
  // TexasHoldembonus: {
  //   redirectUrl: "/casino/ezgevo-texas-holdem-bonus-poker",
  //   code: "1000111",
  //   casino: "ezugi",
  //   provider: "",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/poker/TexasHoldembonus.webp",
  //   alt: "",
  //   name: "Texas Holdem Bonus",
  //   providerName: "Evolution",
  // },
};
